import axios from "./axiosConfig";

export const getCommonSettings = async () => {
  try {
    const response = await axios.get("/settings/common");
    return response.data;
  } catch (error) {
    console.error("Error fetching common settings:", error);
    throw error;
  }
};
